import { Button, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { MosaicComponent, RelationsDeleter, UserAvatar, UserName } from '@/components'
import { ResourceType } from '@/schemas'

import { getNameLink } from './special-project-relations.component'

interface ResourceOKRProps {
  selfId: string
  type: ResourceType
  disabled?: boolean
  canRead: boolean
  relations: any[]
  isSummaryPage?: boolean
  refresh: () => void
}

// 关联组合
export const PortfolioRelations: React.FC<ResourceOKRProps> = ({
  selfId,
  type,
  relations,
  canRead,
  refresh,
  disabled = false,
  isSummaryPage = false,
}) => {
  const { t } = useTranslation()

  const portfolios = (relations || []).map(({ parentPortfolio, parentType }) => {
    const resource = parentPortfolio
    return (
      <div key={resource.selfId} className='flex items-center group'>
        <UserAvatar className='mr-8px' email={resource.email} />
        <div className='text-xs'>
          <Typography.Text className='block'>
            {getNameLink({ name: resource.name, type: resource.type, selfId: resource.selfId })}
          </Typography.Text>
          <Typography.Text type='secondary' className='block'>
            <UserName email={resource.email} />
            <span> - </span>
            <span>{t(ResourceType[parentType])}</span>
            {!disabled && (
              <RelationsDeleter
                parentSelfId={resource.selfId}
                parentType={parentType}
                selfId={selfId}
                type={type}
                onSuccess={refresh}
                isSummaryPage={isSummaryPage}
              >
                <Button type='link' size='small' className='text-xs opacity-0 group-hover:opacity-100'>
                  {t('remove')}
                </Button>
              </RelationsDeleter>
            )}
          </Typography.Text>
        </div>
      </div>
    )
  })
  const content = (
    <div className='space-y-12px'>
      <Typography.Title level={5}>{t('associate portfolio')}</Typography.Title>
      <div className='space-y-12px'>
        {relations && relations.length > 0 ? (
          portfolios
        ) : (
          <Typography.Text type='secondary'>{t('portfolio.nodata')}</Typography.Text>
        )}
      </div>
    </div>
  )

  return canRead ? content : <MosaicComponent />
}
